export const GET_MOVIE_LIST = "GET_MOVIE_LIST";